<template lang="pug">
  .component-backoffice-attachment(v-if="item")
    .driver-license-attachment(v-for="attachment in item.attachments")
      dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'").float-right
        driver-license-attachment-action-buttons(
          :licenseId="item.id",
          :attachmentId="attachment.id",
          :attachmentUrl="attachment.url"
          )
      img(:src="attachment.url")

</template>

<script type="text/babel">
  import Dropdown from "components/structure/foundation/Dropdown"
  import DriverLicenseAttachmentActionButtons from "../structure/ui/actions/DriverLicenseAttachmentActionButtons";

  export default {
    name: "BackofficeDriverLicenseAttachment",
    components: {
      DriverLicenseAttachmentActionButtons,
      Dropdown
    },
    created() {
    },
    methods: {
    },
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-attachment
    display: flex
    justify-content: center
  .driver-license-attachment
    position: relative
    padding: 0 2em 1em 0
    text-align: center
    .component-dropdown
      position: absolute
      right: 1em
      top: 0
</style>



// WEBPACK FOOTER //
// DriverLicenseAttachment.vue?a61ea1a8